export default __webpack_public_path__ + "locales/hy-AM/InviteDialog.json?hash=5095303df8f844fd64b963ddfe632352";